<template>
  <div class="recharge">
    <Breadcrumb></Breadcrumb>
    <div class="recharge-chunk">
      <div class="common-limit line-height-40">
        <el-card class="account" style="margin: 0 0 12px 0;">
          <div slot="header">账号信息</div>
          <div class="message">
            <div style="display:inline-block;margin: 0 32px 0 0;">
              我的账户：<span>{{ user.userName }}</span>
            </div>
            <div style="display:inline-block;">
              账户余额：<span style="color: #f05f6b">{{ user.balance }}</span>
              元
            </div>
          </div>
        </el-card>
        <el-card style="margin: 0 0 12px 0;">
          <div slot="header">选择支付方式</div>

          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="支付宝转账" name="onLine">
              <div class="steps1">第一步：请先转账到以下官方账号</div>
              <div class="info-wrapper line-height-40">
                <div class="info-item">
                  <span class="label">公司名称：</span>
                  <span>{{ finance.alipayName }}</span>
                </div>
                <div class="info-item">
                  <span class="label">支付宝账号：</span>
                  <span> {{ finance.alipayNo }} </span>
                </div>
                <div class="info-item">
                  <span class="label"></span>
                  <span style="color:#aaaaaa;"
                    >请勿使用批量付款，系统可能识别不了订单号</span
                  >
                </div>
              </div>

              <div class="steps2">第二步：请输入支付宝订单号</div>
              <div>
                <el-form>
                  <el-form-item label="充值金额">
                    <span slot="label">
                      <span class="form-required">*</span>
                      支付宝订单号：
                    </span>
                    <el-input
                      style="width: 370px"
                      width="500px"
                      v-model="tranNo"
                    ></el-input>
                    <span style="color:#409eff;margin: 0 0 0 16px;"
                      >订单号示例</span
                    >
                  </el-form-item>
                </el-form>
              </div>
              <el-row
                :span="2"
                style="
                  margin-top: 20px;
                  padding-bottom: 30px;"
              >
                <el-button
                  type="primary"
                  @click="submitForm('01')"
                  size="medium"
                  >提 交</el-button
                >
                <div v-if="false" style="color: #8a8a8a">
                  *提现将收取手续费，请合理安排资金。
                </div>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="银行转账" name="bankTransfer">
              <div class="steps1">第一步：请先转账到以下官方账号</div>
              <div class="info-wrapper line-height-40">
                <div class="info-item">
                  <span class="label">公司名称：</span>
                  <span>{{ finance.accountName }}</span>
                </div>
                <div class="info-item">
                  <span class="label">银行名称：</span>
                  <span>{{ finance.bankName }}</span>
                </div>
                <div class="info-item">
                  <span class="label">银行账号：</span>
                  <span> {{ finance.bankAccount }} </span>
                </div>
                <div class="info-item">
                  <span class="label">开户银行：</span>
                  <span>{{ finance.bankBranch }}</span>
                </div>
              </div>

              <div class="steps2">第二步：确认提交转账金额</div>
              <div>
                <el-form>
                  <el-form-item label="充值金额">
                    <span slot="label">
                      <span class="form-required">*</span>
                      充值金额：
                    </span>
                    <el-input
                      min="0"
                      style="width: 116px"
                      v-model="chargeAmount"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div>
                汇款回执凭证图*：（请上传正常无翻转角度的截图，
                jpg、jpeg、png格式均可）
                <div>
                  <el-upload
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :file-list="fileList"
                    :auto-upload="false"
                    :on-change="handleChange"
                    :limit="1"
                  >
                    <i slot="default" class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div style="margin-top: 10px">
                  <el-button
                    type="primary"
                    @click="submitForm('02')"
                    size="medium"
                    >提交</el-button
                  >
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card>
          <div slot="header">充值记录</div>
          <el-row
            style="background-color:white;padding: 10px 10px 10px 10px;margin-top: -4px;line-height: 1"
          >
            <el-col :span="24">
              <template>
                <el-table :data="dataSource" borderstyle="width: 100%" border>
                  <el-table-column
                    prop="createTime"
                    label="充值时间"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="amount"
                    label="充值金额"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>￥{{ (scope.row.amount * 1).toFixed(2) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="rechargeMode"
                    label="充值方式"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        dictMap["recharge_mode"][scope.row.rechargeMode]
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="operNo"
                    label="充值人员"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="checkStatus"
                    label="状态"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        dictMap["check_status"][scope.row.checkStatus]
                      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination
                  style="margin: 8px 0 0 0;"
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="listRecharge"
                />
              </template>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ElRow from "element-ui/packages/row/src/row"
import Breadcrumb from "@/components/common/Breadcrumb"
// import {
//   alipayPc,
//   getUserProfile,
//   saveUserFund,
// } from '@/api/business/moneyManger'

import { getUserProfile, saveUserFund } from "@/api/system/user"
import { listRecharge, saveRecharge } from "@/api/system/money"
import { uploadFile } from "@/api/upload/upload"
import { getConfigKey } from "@/api/system/config"

//图标变彩色的位置
const m = new Map()
//第一行
m.set("0", ["-60px", "-7px"]) //..键是数值

export default {
  components: { ElRow, Breadcrumb },
  data: function() {
    return {
      user: {},
      totalamount: "",
      input_czje: "",
      tranNo: "",
      //商家集合
      shopList: [{ value: "0", style: "-17px -10px" }],
      //单选
      radio: "", //支付方式
      radio1: "1000.00", //支付选择金额
      zfje: "", //最终显示支付金额
      czje: "", //自定义充值金额
      diaLog: {
        updateDialogFormVisible: false,
      },
      payData: {
        total_amount: "",
        subject: "",
      },
      activeName: "onLine",
      dataSource: [],
      chargeAmount: "", // 充值金额
      fileList: [], // 文件列表
      imgUrl: "", // 文件地址
      uploadFlag: true, //图片上传成功,
      queryParams: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      isSubmit: false,
      finance: {
        alipayName: "",
        alipayNo: "",
        bankName: "",
        bankBranch: "",
        bankAccount: "",
        accountName: "",
      },
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    //查询当前账户余额
    this.getUser()
    this.listRecharge()
  },

  methods: {
    //查询当前账户余额
    getUser() {
      getUserProfile({}).then((response) => {
        this.user = response.user
      })
    },
    // 查询充值记录
    listRecharge() {
      listRecharge({ type: "0", ...this.queryParams }).then((response) => {
        this.dataSource = response.rows
        this.total = response.total
      })
    },
    //更新查询当前账户余额
    saveUserFund(tran_no) {
      var data = {}
      data.totalamount = this.totalamount
      data.tran_no = tran_no
      saveUserFund(data).then((response) => {
        this.user = response.data
        this.user.balance = this.user.balance.toFixed(2)
      })
    },
    //输入自定义充值金额
    changeinput() {
      this.radio1 = ""
      if (!this.input_czje) {
        this.zfje = "0.00"
      } else {
        this.zfje = this.input_czje
      }
    },
    change1(val) {
      this.zfje = this.radio1
      this.input_czje = ""
    },

    //点击切换商家
    change(i, e) {
      //选择彩色图标
      this.shopList[i].style = "-17px " + m.get(e)[0]
      //如果索引是12的图标,则需要调整右边距
      if (e == 12) {
        this.shopList[i].style = "-13px " + m.get(e)[0]
      }
      //循环赋值黑色图标
      for (let key in this.shopList) {
        //如果是当前的索引,则不赋值黑白图标
        if (key == i) {
          continue
        }
        //如果索引是12的图标,则需要调整右边距
        if (key == 12) {
          //赋值黑白图标
          this.shopList[key].style = "-13px " + m.get(key)[1]
          continue
        }
        //赋值黑白图标
        this.shopList[key].style = "-17px " + m.get(key)[1]
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    // 保存文件
    async handleSaveFile() {
      var _self = this
      _self.uploadFlag = false
      _self.imgUrl = ""
      if (this.fileList.length > 0) {
        const file = this.fileList[0]
        if (!file.raw) {
          _self.uploadFlag = true
          _self.imgUrl = file.url
          return
        }
        const { uploadFlag, fileUrl } = await uploadFile(file)
        _self.uploadFlag = uploadFlag
        _self.imgUrl = fileUrl
      }

      // var getSuffix = function(fileName) {
      //   var pos = fileName.lastIndexOf('.')
      //   var suffix = ''
      //   if (pos != -1) {
      //     suffix = fileName.substring(pos)
      //   }
      //   return suffix
      // }
      // const fileList = this.fileList
      // for (const key in fileList) {
      //   if (Object.hasOwnProperty.call(fileList, key)) {
      //     const element = fileList[key]

      //   var filename = new Date().getTime() + getSuffix(element.name)
      //   var formData = new FormData()
      //   //注意formData里append添加的键的大小写
      //   formData.append('key', _self.aliyunOssToken.dir + element.name) //存储在oss的文件路径
      //   formData.append('OSSAccessKeyId', _self.aliyunOssToken.accessid) //accessKeyId
      //   formData.append('policy', _self.aliyunOssToken.policy) //policy
      //   formData.append('Signature', _self.aliyunOssToken.signature) //签名
      //   //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

      //   formData.append('file', element.raw)
      //   formData.append('success_action_status', 200) //成功后返回的操作码

      //   var url = _self.aliyunOssToken.host
      //   _self.imgUrl =
      //     _self.aliyunOssToken.host +
      //     '/' +
      //     _self.aliyunOssToken.dir +
      //     filename
      //   $.ajax({
      //     url: url,
      //     type: 'POST',
      //     data: formData,
      //     // async: false,
      //     cache: false,
      //     contentType: false,
      //     processData: false,
      //     success: function(data) {
      //       // _self.imageGroup.push({
      //       //   imageUrl: fileUrl,
      //       //   isMain: _self.imageGroup.length === 0 ? true : false,
      //       // })
      //       _self.uploadFlag = true
      //     },
      //     error: function(data) {},
      //   })
      // }
      // }
    },

    //充值
    async submitForm(rechargeMode) {
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      let params = {
        rechargeMode: rechargeMode,
        amount: "",
        picUrl: "",
        tranNo: "",
      }
      try {
        if (rechargeMode === "01") {
          params.amount = this.zfje
          params.tranNo = this.tranNo
          if (this.zfje == "") {
            this.isSubmit = false
            this.$message("请选择或输入支付金额")
            return
          }
          if (this.radio == "") {
            this.isSubmit = false
            this.$message("请选择支付方式")
            return
          }
          if (this.tranNo == "") {
            this.isSubmit = false
            this.$message("请输入支付宝订单号")
            return
          }
        } else if (rechargeMode === "02") {
          params.amount = this.chargeAmount
          params.picUrl = ""
          if (this.chargeAmount <= 0) {
            this.$message("请输入充值金额")
            this.isSubmit = false
            return
          }
          await this.handleSaveFile()
          params.picUrl = this.imgUrl
          if (!this.uploadFlag) {
            this.isSubmit = false
            this.$message("请上传汇款回执凭证图")
            return
          }
        }
        let res = await saveRecharge(params)

        if (res.code === 200) {
          let result = await getUserProfile({})
          this.user = result.user

          this.listRecharge()
          this.msgSuccess("提交成功")
          this.fileList = []
          this.uploadFlag = false
          this.imgUrl = ""
          this.chargeAmount = ""
          this.input_czje = ""
          this.radio1 = "1000.00"
          this.zfje = "1000.00"
          this.isSubmit = false
        } else {
          this.msgError("提交失败")
          this.isSubmit = false
        }
      } catch (error) {
        this.isSubmit = false
      } finally {
        // this.isSubmit = false
      }
    },

    handleClick(tab, event) {},

    /*初始化一些页面功能*/
    async init() {
      // 初始化默认选中第一列
      this.change1(this.radio1)
      if (this.shopList != null) {
        this.radio = this.shopList[0].value
        this.change(0, this.shopList[0].value)
      }

      this.finance.alipayName = (await getConfigKey("alipay_name")).msg
      this.finance.alipayNo = (await getConfigKey("alipay_no")).msg
      this.finance.bankName = (await getConfigKey("bank_name")).msg
      this.finance.bankBranch = (await getConfigKey("bank_ranch")).msg
      this.finance.bankAccount = (await getConfigKey("bank_account")).msg
      this.finance.accountName = (await getConfigKey("account_name")).msg
      // this.finance.bankNo = (await getConfigKey("alipay_name")).msg
    },
    //格式化提现金额
    formatter(row, column) {
      return row.amount ? (row.amount * 1).toFixed(2) : ""
    },
  },

  mounted() {
    this.init() //初始化
  },
}
</script>

<style scope>
@import "../../../assets/css/iconfont/iconfont.css";

.cc {
  margin: 0px 0px 0 0;
  border-radius: 2px;
  border: 0px solid #ebeef5;
  width: 95px;
  height: 22px;
  background: url(../../../assets/images/alipay120.png?v=7.0);
  float: right;
}
/*设置头部颜色*/
.bb .el-dialog__header {
  background-color: #eeeeee;
}
.deleteRadio .el-radio__input {
  display: none;
}

.recharge {
  width: 100%;
}
.recharge-chunk {
  margin: 8px 0 0 0;
}
.recharge-chunk .title {
  font-size: 17px;
  font-weight: bold;
  margin: 20px 0 15px 20px;
}
.recharge-chunk .message {
  background-color: white;
  padding: 10px;
  margin: 0 15px;
  line-height: 30px;
}
.recharge-chunk .el-tabs {
  margin: 0 10px;
}
.recharge-chunk .el-tabs__item {
  font-size: 15px;
  font-weight: bold;
}
.recharge-chunk .marginTop {
  margin-top: 15px;
}
.recharge-chunk .el-radio.is-bordered.is-checked {
  border-color: #ff2929;
}
.recharge-chunk .el-input--small .el-input__inner {
  height: 39px;
}

.icon-checked {
  position: absolute;
  right: 0;
  bottom: -1px;
  font-size: 27px;
  color: #ff2929;
}

.recharge-chunk .el-radio-button {
  margin-right: 15px;
  width: 135px;
}
.recharge-chunk .el-radio-button__inner {
  width: 135px;
  border: 1px solid #b2b3b6 !important;
  border-radius: 3px !important;
}
.recharge-chunk .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: black;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #ff2929 !important;
  box-shadow: 0 0 0 0;
}

.steps1 {
  color: #0000ff;
}
.steps2 {
  color: #0000ff;
  margin: 16px 0 0 0;
}
.info-wrapper {
  border: 1px solid #ccc;
}
.info-wrapper .info-item {
  padding: 0 10px;
  background: #fff;
}
.info-wrapper .info-item:nth-child(odd) {
  background: #f7f7f7;
}
.el-upload--picture-card {
  width: 74px;
  height: 74px;
  line-height: 84px;
}
</style>
